import React from "react";
import { Grid, Pagination, Typography } from "../../../components";
export const DataGridPagination = ({ currentPage, numberOfPages, setPage, showing, }) => {
    return (React.createElement(Grid, { container: true, gap: 8, alignItems: "center", sx: { padding: 4 } },
        React.createElement(Grid, { item: true },
            React.createElement(Pagination, { currentPage: currentPage, numberOfPages: numberOfPages, color: "surface", variant: "small", onNext: (next) => setPage(next), onBack: (next) => setPage(next), onPageChange: (next) => setPage(next), slotProps: {
                    backButton: {
                        variant: "minimal",
                    },
                    nextButton: {
                        variant: "minimal",
                    },
                    pageButton: {
                        variant: "ghost",
                        sx: {
                            padding: 1,
                        },
                    },
                } })),
        React.createElement(Grid, { item: true, display: "flex", flexDirection: "row", gap: 1 },
            React.createElement(Typography, { variant: "body3" }, "Showing"),
            React.createElement(Typography, { variant: "body3", fontWeight: "bold" }, showing.current),
            React.createElement(Typography, { variant: "body3" }, "from"),
            React.createElement(Typography, { variant: "body3", fontWeight: "bold" }, showing.all))));
};
//# sourceMappingURL=DataGridPagination.js.map